import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { metronic } from "../../_metronic";
import CuestionarioReducer from "../widgets/reducers/reducer-cuestionarioActivo";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  i18n: metronic.i18n.reducer,
  builder: metronic.builder.reducer,
  cuestionario: CuestionarioReducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
